import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "sheet-toolbar" }
const _hoisted_3 = { class: "badge-and-cta" }
const _hoisted_4 = { class: "number" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "relative z-10" }
const _hoisted_7 = { class: "block" }
const _hoisted_8 = { class: "grid grid-3" }
const _hoisted_9 = { class: "cell" }
const _hoisted_10 = { class: "cell" }
const _hoisted_11 = { class: "value font-bold" }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = { class: "grid grid-4" }
const _hoisted_14 = { class: "cell" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "cell" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "cell" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "cell" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = {
  key: 0,
  class: "block"
}
const _hoisted_23 = { class: "grid grid-4" }
const _hoisted_24 = { class: "cell" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "cell" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "cell" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "cell" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "cell" }
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "block" }
const _hoisted_35 = { class: "grid grid-3" }
const _hoisted_36 = { class: "cell" }
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "cell" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = {
  key: 0,
  class: "cell"
}
const _hoisted_41 = { class: "value" }
const _hoisted_42 = {
  key: 1,
  class: "cell"
}
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "text-slate-500 font-normal"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 2,
  class: "text-slate-500 font-normal"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "text-slate-500 font-normal"
}

import { computed, ref, nextTick } from 'vue'
// @ts-ignore
import html2pdf from 'html2pdf.js'
import { getSessionPrefix } from '@/utils/common'   
import pdfBg from '@/assets/pdf_bg.jpg'   


export default /*@__PURE__*/_defineComponent({
  __name: 'Voucher',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props
const data = props.data

const commentText = computed(() => {
  // try common server keys first
  const v =
    data?.contact?.comments ??
    data?.contact?.comment ??
    data?.comments ??
    data?.contact_comments ??
    data?.contact?.notes ??
    data?.notes ??
    data?.search?.comments ??
    data?.meta?.comments ??
    null

  if (typeof v === 'string' && v.trim() !== '') return v.trim()

  // fallback to what the user typed on the form (stored locally)
  try {
    const prefix = getSessionPrefix()
    const raw = localStorage.getItem(`${prefix}_contact_details`)
    if (raw) {
      const obj = JSON.parse(raw)
      if (typeof obj?.comments === 'string' && obj.comments.trim() !== '') {
        return obj.comments.trim()
      }
    }
  } catch {}

  return '—'
})

const carDisplayName = computed(() => {
  if (!data?.car) return '—'
  
  const maxPax = Number(data.car.type?.passengers || 0)
  const maxBags = Number(data.car.type?.bags || 0)
  const enteredPax = Number(data.car_meta?.type?.passengers ?? data.contact?.passengers ?? 0)
  const enteredBags = Number(data.car_meta?.type?.bags ?? data.contact?.bags ?? 0)
  const capacityExceeded = (enteredPax > 0 && enteredPax > maxPax) || (enteredBags > 0 && enteredBags > maxBags)
  
  if (data.status === 'need_confirmation' && capacityExceeded) {
    return `Vehicle Category (${data.car.type?.name || 'On Request'})`
  }
  
  return data.car.name || '—'
})

/* ===== Duration helpers ===== */
const hoursPerDay = computed(() => data?.car_meta?.hours_per_day ?? data?.car?.chaufferLocation?.hours_per_day ?? null)
const kmPerDay = computed(() => data?.car_meta?.km_per_day ?? data?.car?.chaufferLocation?.km_per_day ?? null)

const HOURS_PER_DAY = computed(() => Number(hoursPerDay.value || 10))
const hours = computed(() => Number(data?.search?.hours ?? 0))
const isFullDay = computed(() =>
  (data?.search?.package === 'full_day') ||
  (hours.value >= HOURS_PER_DAY.value && hours.value % HOURS_PER_DAY.value === 0)
)
const days = computed(() =>
  isFullDay.value ? Math.ceil(hours.value / HOURS_PER_DAY.value) : 0
)

/* ===== Status + money ===== */
const isPaid = computed(() => {
  const s = (data?.payment?.status || '').toString().toLowerCase()
  return ['paid', 'success', 'captured', 'confirmed'].includes(s) || data?.status === 'confirmed'
})
const isWalletPaid = computed(() => {
  return data?.payment?.wallet === 'wallet' || data?.payment_details?.wallet === 'wallet'
})
const getPaymentStatusText = computed(() => {
  if (!isPaid.value) return 'Not Paid'
  return isWalletPaid.value ? 'Agency Credit' : 'Paid'
})
const getPaymentStatusClass = computed(() => {
  if (!isPaid.value) return 'text-rose-600'
  return isWalletPaid.value ? 'text-blue-600' : 'text-emerald-600'
})
const headerText = computed(() => (isPaid.value ? 'Booking Voucher' : 'Reservation Request'))
const formattedTotal = computed(() => {
  const amount = Number(data?.totalAmount || 0)
  const currency = (data?.currency || 'USD').toUpperCase()
  return `${amount.toFixed(2)} ${currency}`
})
const toDash = (v: any) => (v === 0 || v ? String(v) : '—')
const capitalize = (s?: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '')

/* ===== Export to PDF ===== */
const sheet = ref<HTMLElement | null>(null)
const exporting = ref(false)

const exportPDF = async () => {
  if (!sheet.value || exporting.value) return
  exporting.value = true
  await nextTick()

  const name = isPaid.value ? `Voucher_${data?.number || 'booking'}` : `Reservation_Request_${data?.number || 'booking'}`

  const opt: any = {
    margin:       [12, 12, 18, 12],          // top, left/right, bottom
    filename:     `${name}.pdf`,
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  { scale: 2, useCORS: true, backgroundColor: '#ffffff' },
    jsPDF:        { unit: 'pt', format: 'a4', orientation: 'portrait' },
    pagebreak:    { mode: ['css', 'avoid-all', 'legacy'] }
  }

  try {
    await html2pdf().from(sheet.value).set(opt).save()
  } finally {
    exporting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(data))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: "/assets/logo.png",
              alt: "Vehitra World",
              class: "logo"
            }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                class: _normalizeClass(["status-badge", isPaid.value ? 'badge-paid' : 'badge-pending'])
              }, _toDisplayString(headerText.value), 3),
              _createElementVNode("span", _hoisted_4, "#" + _toDisplayString(_unref(data)?.number), 1)
            ])
          ]),
          _createElementVNode("div", {
            ref_key: "sheet",
            ref: sheet,
            class: "sheet relative overflow-hidden"
          }, [
            _createElementVNode("img", {
              src: _unref(pdfBg),
              class: "absolute inset-0 w-full h-full object-cover pointer-events-none opacity-25",
              "data-html2canvas-ignore": "false",
              "aria-hidden": "true"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("section", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "block-title" }, "Booking Summary", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "cell" }, [
                    _createElementVNode("div", { class: "label" }, "Booking Status:"),
                    _createElementVNode("div", { class: "value text-emerald-600 font-bold" }, "Under Process"),
                    _createElementVNode("div", { class: "text-[11px] text-slate-500 mt-0.5" }, "(one of our agent will get back to you shortly)")
                  ], -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "label" }, "Payment Status:", -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["value font-bold", getPaymentStatusClass.value])
                    }, _toDisplayString(getPaymentStatusText.value), 3)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "Booking Number:", -1)),
                    _createElementVNode("div", _hoisted_11, "#" + _toDisplayString(_unref(data)?.number), 1)
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_12, [
                _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "block-title" }, "Contact", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, "Name:", -1)),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(data).contact?.name || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "Email:", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      (_unref(data).contact?.email)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(data).contact.email), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("—")
                          ], 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Phone:", -1)),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(data).contact?.phone || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "Comments:", -1)),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(commentText.value), 1)
                  ])
                ])
              ]),
              (_unref(data).car)
                ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
                    _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "block-title" }, "Car", -1)),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, "Car:", -1)),
                        _createElementVNode("div", _hoisted_25, _toDisplayString(carDisplayName.value), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label" }, "Type:", -1)),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(data).car?.type?.name || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label" }, "Bags:", -1)),
                        _createElementVNode("div", _hoisted_29, _toDisplayString(toDash(_unref(data).car_meta?.type?.bags ?? _unref(data).car?.type?.bags)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label" }, "Passengers:", -1)),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(toDash(_unref(data).car_meta?.type?.passengers ?? _unref(data).car?.type?.passengers)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "label" }, "Doors:", -1)),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(toDash(_unref(data).car_meta?.type?.doors ?? _unref(data).car?.type?.doors)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_34, [
                _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "block-title" }, "Locations", -1)),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "label" }, "Pick Up:", -1)),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(data).search?.pickUp?.location?.name || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "label" }, "Date and time:", -1)),
                    _createElementVNode("div", _hoisted_39, [
                      _createTextVNode(_toDisplayString(_unref(data).search?.pickUp?.date || '—') + " ", 1),
                      (_unref(data).search?.pickUp?.time)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" – " + _toDisplayString(_unref(data).search.pickUp.time), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_unref(data).search?.type === 'distance')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "label" }, "Drop Off:", -1)),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(data).search?.dropOff?.location?.name || '—'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(data).search?.type === 'hourly')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "label" }, "Duration:", -1)),
                        _createElementVNode("div", _hoisted_43, [
                          (isFullDay.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(days.value) + " day", 1),
                                (days.value > 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, "s"))
                                  : _createCommentVNode("", true),
                                (hoursPerDay.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                                      _createTextVNode(" (Daily " + _toDisplayString(hoursPerDay.value) + " hrs", 1),
                                      (Number(kmPerDay.value) > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, " & " + _toDisplayString(kmPerDay.value) + " km", 1))
                                        : _createCommentVNode("", true),
                                      _cache[19] || (_cache[19] = _createTextVNode(")"))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_47, " (Full Day)"))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(hours.value) + " hour", 1),
                                (Number(hours.value) > 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "s"))
                                  : _createCommentVNode("", true),
                                (hoursPerDay.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, " (Max " + _toDisplayString(hoursPerDay.value) + " hrs per day)", 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("section", { class: "block" }, [
                _createElementVNode("h2", { class: "block-title" }, "Cancellation and amendment policy"),
                _createElementVNode("div", { class: "policy-box" }, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "No-show charges will be 100%."),
                    _createElementVNode("li", null, [
                      _createTextVNode(" Please review our "),
                      _createElementVNode("a", {
                        href: "/terms-and-conditions",
                        target: "_blank",
                        rel: "noopener"
                      }, "Terms & Conditions"),
                      _createTextVNode(" for cut-off times and fees. ")
                    ])
                  ])
                ])
              ], -1))
            ])
          ], 512)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})